import styled from "styled-components";

export const StatusDiv = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  border-radius: 50px;
  background-color: ${(props) => props.color};
  padding: 0px 12px;
  width: fit-content;
  white-space: nowrap;
  font-size: 13px;
  height: 25px;

  span {
    text-align: center;
    font-weight: 600;
    color: #fff;
  }
`;
